export const API_CONFIG = {
    baseURL: 'https://api.themoviedb.org/3',
    apiKey: 'd3e9ceef8e7c6b6ed9b60977e21ccdc4',
    imageBaseURL: 'https://image.tmdb.org/t/p',
};

export const IMAGE_SIZES = {
    poster: {
        small: 'w185',
        medium: 'w342',
        large: 'w500',
        original: 'original',
    },
    backdrop: {
        small: 'w300',
        medium: 'w780',
        large: 'w1280',
        original: 'original',
    },
};
